import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const AITutorCallComplete = dynamic(() => import('../../new-portal/ai-tutor/AITutorCallComplete'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})

const AITutorCallCompleteActivity: ActivityComponentType = () => {
  const router = useAppRouter()

  const {
    threadId,
    statistics, // base64url encoded string
  } = router.query

  const callStatistics = JSON.parse(
    atob(
      (statistics as string)
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        .padEnd(Math.ceil((statistics as string).length / 4) * 4, '=')
    )
  )

  console.log('Call Statistics:', callStatistics)

  return (
    <WebviewStackContainer height="0px" title={null} border={false}>
      <AITutorCallComplete threadId={Number(threadId)} callStatistics={callStatistics} />
    </WebviewStackContainer>
  )
}

export default AITutorCallCompleteActivity
